import { TCoreTextOptions } from '../types/options';
import { px } from '../utils/styles';

export const buildTextCssVars = (palette: TCoreTextOptions): Record<string, string> => {
    const margin = palette.margin ?? {};
    const padding = palette.padding ?? {};

    const vars: Record<string, string | undefined> = {
        // typography
        '--cw-txt-font-family': palette.font,
        '--cw-txt-font-weight': typeof palette.fontStyle?.fontWeight === 'number' ? palette.fontStyle.fontWeight.toString() : undefined,
        '--cw-txt-font-size': px(palette.fontStyle?.fontSize),
        '--cw-txt-line-height': px(palette.fontStyle?.lineHeight),
        '--cw-txt-letter-spacing': px(palette.fontStyle?.letterSpacing),
        '--cw-txt-text-align': palette.textAlign,
        '--cw-txt-max-lines': typeof palette.maxLines === 'number' ? String(palette.maxLines) : undefined,
        // color
        '--cw-txt-color': palette.main,
        '--cw-txt-colorDisabled': palette.disabled?.main,
        '--cw-txt-text-transform': palette.textTransform,
        // margin
        '--cw-txt-margin-top': px(margin.top),
        '--cw-txt-margin-right': px(margin.right),
        '--cw-txt-margin-bottom': px(margin.bottom),
        '--cw-txt-margin-left': px(margin.left),
        // padding
        '--cw-txt-padding-top': px(padding.top),
        '--cw-txt-padding-right': px(padding.right),
        '--cw-txt-padding-bottom': px(padding.bottom),
        '--cw-txt-padding-left': px(padding.left),
    };

    return Object.fromEntries(Object.entries(vars).filter((entry): entry is [string, string] => entry[1] !== undefined));
};
